/* unplugin-vue-components disabled */import script from "./ThirdPartyBatchDisableModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThirdPartyBatchDisableModal.vue?vue&type=script&setup=true&lang=ts"

import "./ThirdPartyBatchDisableModal.vue?vue&type=style&index=0&id=14c2285a&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c2285a"]])

export default __exports__